import { envConfig } from "../../../../../utils/config";
import { getEventEndDateTime, getEventStartDateTime } from "../utils";
import { IEvent } from "./type";

export const normalizeDate = (date: Date | string) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
};


export const getEventDates = (event: IEvent) => ({
    start: getEventStartDateTime(event),
    end: getEventEndDateTime(event),
});

function decodeQueryParam(raw: string | null): string | null {
    if (!raw) {
        return null;
    }
    try {
        const decoded = window.CookieUtils.decodefn(raw, envConfig.APP_API_SECRET).trim();
        return decoded !== '' ? decoded : null;
    } catch {
        return null;
    }
}

export const parseCalendarQueryDate = (raw: string | null): Date | null => {
    for (const value of [decodeQueryParam(raw), raw]) {
        if (!value) {
            continue;
        }
        const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
        const date = dateOnly
            ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
            : new Date(value);
        if (!Number.isNaN(date.getTime())) {
            return date;
        }
    }
    return null;
};

export const parseCalendarQueryEventId = (raw: string | null): number | null => {
    const id = Number(decodeQueryParam(raw) ?? raw);
    return Number.isInteger(id) && id > 0 ? id : null;
};